import React from 'react';
import { Text } from '@wix/design-system';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { useExperiments } from '@wix/wix-experiments-react';
import { useTranslation } from '../../../hooks/use-translation';
export function PriceBadge({ app }) {
    const t = useTranslation();
    const { experiments } = useExperiments();
    const fixedPrice = app?.appSavedPrice && app?.appSavedPrice !== 0
        ? Number(app?.appSavedPrice).toFixed(2)
        : '';
    const [currencyToString] = usePremiumCurrencyFormatter({
        currencySettings: {
            [app?.webSolutionBase.pricing?.currencySettings?.code]: {
                symbol: app?.webSolutionBase.pricing?.currencySettings?.symbol,
                decimalSep: app?.webSolutionBase.pricing?.currencySettings?.decimalSeparator,
                groupSep: app?.webSolutionBase.pricing?.currencySettings?.groupSeparator,
                negPrefix: app?.webSolutionBase.pricing?.currencySettings?.negativePrefix,
                negSuffix: app?.webSolutionBase.pricing?.currencySettings?.negativeSuffix,
                posPrefix: '¤',
                posSuffix: '',
                fractionSize: 2,
            },
        },
        currencyCode: app?.webSolutionBase.pricing?.currencySettings?.code,
    });
    const showFullPrices = experiments.enabled('specs.marketplace.fullPrices');
    const moveBundleToBenefitsEnabled = experiments.enabled('specs.app-market.MoveBundlesToBenefits');
    const shouldShowNewBundleBadge = experiments.enabled('solution.page.freeBundleNotInstalled');
    const savedPrice = showFullPrices
        ? currencyToString(Number(fixedPrice))
        : `$${fixedPrice}`;
    return !shouldShowNewBundleBadge ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        !moveBundleToBenefitsEnabled && fixedPrice !== '' && (React.createElement("span", { style: { textDecoration: 'line-through' } },
            React.createElement(Text, { size: 'small', weight: 'thin', secondary: true }, savedPrice))),
        React.createElement("span", { style: moveBundleToBenefitsEnabled ? { position: 'relative', bottom: '2px' } : { marginLeft: '6px' } },
            React.createElement(Text, { size: moveBundleToBenefitsEnabled ? 'tiny' : 'small', weight: 'thin', skin: 'success', secondary: true }, t(moveBundleToBenefitsEnabled ? 'manage-apps.app-price.free-for-you' : 'manage-apps.app-price.free'))))) : (React.createElement("span", null,
        React.createElement(Text, { size: 'tiny', weight: 'thin', skin: 'success' }, t('manage-apps.page.freeBundleNotInstalled'))));
}
//# sourceMappingURL=price-badge.js.map